import IC from "../../../assets/images/HomeDigital/IC.svg";
import web01 from "../../../assets/images/HomeDigital/web01.svg";
import pcer from "../../../assets/images/HomeDigital/pcer.webp";
import mock from "../../../assets/images/HomeDigital/mock.webp";
import laptop12 from "../../../assets/images/HomeDigital/laptop12.svg";
import computer1 from "../../../assets/images/HomeDigital/computer1.svg";
import mock1 from "../../../assets/images/HomeDigital/mock1.webp";
import mobil4e from "../../../assets/images/HomeDigital/mobil4e.svg";
import mock3 from "../../../assets/images/HomeDigital/mock3.webp";
import { Button } from "flowbite-react";
import goo from "../../../assets/images/NewEvent/goo.svg";
import appp from "../../../assets/images/NewEvent/appp.svg";
import get1 from "../../../assets/images/NewEvent/get1.svg";
import pl1 from "../../../assets/images/NewEvent/pl1.svg";
import donw1 from "../../../assets/images/NewEvent/donw1.svg";
import sto from "../../../assets/images/NewEvent/sto.svg";

export default function HomeGigital() {
  return (
    <div className="w-full container mx-auto py-[50px] px-[20px] grid grid-cols-1 md:flex-col gap-8 md:gap-9">
      <div className="w-full flex flex-row items-center md:justify-center gap-2">
        <div>
          <img src={IC} alt="ic" className="block md:hidden" />
        </div>
        <div className="text-[20px] font-semibold text-[#053CC8] md:text-[32px] ">
          GIẢI PHÁP CHUYỂN ĐỔI SỐ
        </div>
      </div>
      <div className="w-full flex flex-col items-center gap-9">
        <div className="w-full flex flex-col md:gap-9 md:flex-row-reverse">
          <div className="w-full md:basis-4/12 flex items-center justify-center md:justify-end">
            <img src={pcer} alt="pcer" className="md:w-[400px] md:h-auto" />
          </div>
          <div className="w-full md:basis-8/12 flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center bg-postc rounded-full">
                <img src={web01} alt="web01" />
              </div>
              <div className="text-[20px] text-[#053CC8] font-medium md:text-[24px] md:font-semibold">
                Blue Rise ERP
              </div>
            </div>
            <div className="w-full md:w-[764px] md:text-[18px] md:font-normal text-[16px] text-[#333333]">
              Website quản trị toàn bộ hoạt động của trung tâm, chuỗi trung tâm
              và hành trình trải nghiệm của khách hàng với các nhóm tính năng
              hàng đầu: CRM, Trải nghiệm đầu vào, Quản lý ghi danh, Quản lý lịch
              học, Quản lý học sinh, Quản lý giáo viên, Báo cáo doanh thu, Thống
              kê giờ dạy, Tự động điểm danh, Chấm công.....{" "}
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col md:gap-9 md:flex-row">
          <div className="w-full md:basis-4/12 flex items-center justify-center md:justify-start">
            <img src={mock} alt="mock" />
          </div>
          <div className="w-full md:basis-8/12 flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center bg-postc rounded-full">
                <img src={laptop12} alt="web01" />
              </div>
              <div className="text-[20px] text-[#053CC8] font-medium md:text-[24px] md:font-semibold">
                Blue Rise Edu
              </div>
            </div>
            <div className="w-full md:text-[18px] md:w-[764px] md:font-normal text-[16px] text-[#333333]">
              Trang làm việc dành riêng cho giáo viên với các nhóm tính năng
              chuyên biệt hỗ trợ quản lý thông tin lớp học, quản lý học sinh,
              soạn thảo bài giảng, đề thi, nhận xét, chấm điểm tự động. Tra cứu
              dữ liệu điểm danh, công, lương....
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col md:gap-9 md:flex-row-reverse">
          <div className="w-full md:basis-4/12 flex items-center justify-center md:justify-end">
            <img src={mock1} alt="pcer" />
          </div>
          <div className="w-full md:basis-8/12 flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center bg-postc rounded-full">
                <img src={computer1} alt="web01" />
              </div>
              <div className="text-[20px] text-[#053CC8] font-medium md:text-[24px] md:font-semibold">
                Blue Rise PC App
              </div>
            </div>
            <div className="w-full md:text-[18px] md:w-[764px] md:font-normal text-[16px] text-[#333333]">
              Môi trường giảng dạy và học tập online tuyệt vời. Mô phỏng 80% lớp
              học truyền thông với đầy đủ các công cụ tương tác hàng đầu trên
              thị trường như: bảng đen, bộ đếm giờ, bộ dụng cụ học tập, công cụ
              tạo game, trao cúp vinh danh, bộ công cụ cử chỉ....
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col md:gap-9 md:flex-row">
          <div className="w-full md:basis-4/12 flex items-center justify-center md:justify-end">
            <img src={mock3} alt="pcer" />
          </div>
          <div className="w-full md:basis-8/12 flex flex-col gap-2">
            <div className="flex flex-row items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center bg-postc rounded-full">
                <img src={mobil4e} alt="web01" />
              </div>
              <div className="text-[20px] text-[#053CC8] font-medium md:text-[24px] md:font-semibold">
                Blue Rise Mobile App
              </div>
            </div>
            <div className="w-full md:text-[18px] md:w-[764px] md:font-normal text-[16px] text-[#333333]">
              Ứng dụng hoàn hảo tương tác giữa trung tâm, phụ huynh và học sinh
              với các tính năng: thông báo lịch học, thống kê học phí, đánh giá
              năng lực, điểm số, làm bài tập, bài kiểm tra, đơn xin nghỉ, chuyên
              cần, sổ liên lạc điện tử...
            </div>
            <div className="w-full">
              <div className="mt-4 flex flex-col sm:flex-row md:flex-row gap-4 w-full">
                <Button
                  href="https://play.google.com/store/apps/details?id=com.bluerise"
                  target="_blank"
                  className="bg-white shadow-custom-light3 hover:bg-slate-100 border-2 w-full rounded-[68px] px-[16px] py-[12px] border-solid border-[#E2E2E2] flex items-center justify-center gap-6"
                >
                  <div className="flex items-center gap-4 w-full">
                    <img
                      src={goo}
                      alt="Google Play"
                      className="w-[28px] h-[31px]"
                    />
                    <div>
                      <img src={get1} alt="ge" />
                      <img src={pl1} alt="pl" className="mt-1" />
                    </div>
                  </div>
                </Button>
                <Button
                  href="https://apps.apple.com/gb/app/bluerise-t%E1%BB%91i-%C6%B0u-qu%E1%BA%A3n-l%C3%BD/id6751710088"
                  target="_blank"
                  className="bg-white border-2 shadow-custom-light3 hover:bg-slate-100 w-full border-solid border-[#E2E2E2] rounded-[68px] px-[16px] gap-4 py-[12px] flex items-center justify-center"
                >
                  <div className="flex items-center gap-4">
                    <img
                      src={appp}
                      alt="App Store"
                      className="w-[28px] h-[34px]"
                    />
                    <div className="flex flex-col gap-1">
                      <img src={donw1} alt="do" />
                      <img src={sto} alt="ss" />
                    </div>
                  </div>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
